import apiInstance from "@/axios";

export {
  getCreatedCompanyId,
  getManufacturerFaviconErrorCode,
} from "./favicon-workflow.mjs";

export const MAX_FAVICON_SIZE_BYTES = 1024 * 1024;

export const validateManufacturerFaviconFile = (file) => {
  if (!file) return "PNG 파일을 선택해 주세요.";
  if (file.type !== "image/png") return "PNG 파일만 업로드할 수 있습니다.";
  if (file.size > MAX_FAVICON_SIZE_BYTES) {
    return "파일 크기는 1MiB 이하여야 합니다.";
  }
  return "";
};

export const getManufacturerFaviconUrl = (payload) =>
  payload?.faviconUrl ??
  payload?.result?.faviconUrl ??
  payload?.company?.faviconUrl ??
  "";

const getCompanyFaviconPath = (companyId) => {
  if (!companyId) throw new Error("제조사 ID가 필요합니다.");
  return `/companies/certi-admin/manufacturers/${encodeURIComponent(
    companyId
  )}/favicon`;
};

export const uploadManufacturerFavicon = async (companyId, file) => {
  const validationError = validateManufacturerFaviconFile(file);
  if (validationError) throw new Error(validationError);

  const formData = new FormData();
  formData.append("file", file);
  const response = await apiInstance.post(
    getCompanyFaviconPath(companyId),
    formData,
    {
      showGlobalLoading: false,
    }
  );
  return response.data;
};

export const deleteManufacturerFavicon = async (companyId) => {
  const response = await apiInstance.delete(getCompanyFaviconPath(companyId), {
    showGlobalLoading: false,
  });
  return response.data;
};
